import React from 'react';

export const GetStarted=()=> (
     <div>
        <h1>Hello Started</h1>  
     </div>
)
